export const GET_PRODUCTS = 'Get_Products';